// src/services/productionService.ts
// StrymHub Studios — the productions the studio develops, shoots and releases.

import { buildQuery, studioRequest } from './studioApi';
import type { PagedResult, Production, ProductionSummary } from '../types/studio';

export interface ProductionQuery {
  stage?: string;
  format?: string;
  search?: string;
  page?: number;
  size?: number;
}

export const productionService = {
  getProductions(
    query: ProductionQuery = {},
    signal?: AbortSignal,
  ): Promise<PagedResult<ProductionSummary>> {
    const search = buildQuery({
      stage: query.stage,
      format: query.format,
      search: query.search,
      page: query.page ?? 0,
      size: query.size ?? 24,
    });
    return studioRequest<PagedResult<ProductionSummary>>(`/productions${search}`, {
      withAuth: false,
      signal,
    });
  },

  getFeatured(signal?: AbortSignal): Promise<ProductionSummary[]> {
    return studioRequest<ProductionSummary[]>('/productions/featured', { withAuth: false, signal });
  },

  getProduction(slug: string, signal?: AbortSignal): Promise<Production> {
    return studioRequest<Production>(`/productions/${encodeURIComponent(slug)}`, {
      withAuth: false,
      signal,
    });
  },
};

export default productionService;
